import { instance } from '@/utils/http.js'

// 根据科目获取一二级知识点
export const getLevel12Knowledge = function (params) {
  return instance({
    url: '/api/v1/question/knowledge',
    method: 'get',
    params
  })
}